import React, { Component } from "react";
import moment from "moment";
import { Link } from "react-router-dom";

import { Avatar, Badge, Divider, List, Pagination, Spin } from "antd";

import { dateFormat } from "utils";

const actionText = {
  Message: {
    create: "a envoyé un message",
  },
  Note: {
    create: "a créé une Intervention",
    update: "a modifié une Intervention",
    delete: "a supprimé une Intervention",
  },
  Incident: {
    create: "a créé un Incident",
    update: "a modifié un Incident",
    delete: "a supprimé un Incident",
  },
  Compliance: {
    create: "a créé une Non-conformité",
    update: "a modifié une Non-conformité",
    delete: "a supprimé une Non-conformité",
  },
};

const actionLink = {
  Message: (id) => ({
    pathname: "/chat",
    search: `${id}`,
    state: { fromNotif: id },
  }),
  Note: (id) => "/sse/" + id,
  Incident: (id) => "/incidents/" + id,
  Compliance: (id) => "/notes/" + id,
};

const Item = ({ item, onClick, userLastNotifiedDate }) => (
  <List.Item>
    <List.Item.Meta
      avatar={
        item._isRealTime || item.date > userLastNotifiedDate ? (
          <Badge dot>
            <Avatar icon="user" />
          </Badge>
        ) : (
          <Avatar icon="user" />
        )
      }
      title={
        <span className="notification-item-title">
          <Link to={actionLink[item.type](item.action_id)} onClick={onClick}>
            <b>{item.user_name}</b>
            <span>{` ${
              (actionText[item.type] && actionText[item.type][item.action_type]) || item.action_type
            }`}</span>
          </Link>
          <span className="date">{moment(item.date).format(`${dateFormat} HH:mm`)}</span>
        </span>
      }
      description={item.text}
    />
  </List.Item>
);

// Composant qui présente une liste de notifications.
export default class NotificationsList extends Component {
  constructor(props) {
    super(props);
    this._isMounted = true;
    this.state = {
      loading: props.loading,
      lastReceivedTime: 0,
    };
  }

  static getDerivedStateFromProps(props, state) {
    if (
      state.loading &&
      props.notifications?.lastReceivedTime &&
      props.notifications.lastReceivedTime > state.lastReceivedTime
    ) {
      return {
        loading: false,
        lastReceivedTime: props.notifications.lastReceivedTime,
      };
    }
    return null;
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  fetchData = (page) => {
    this.setState({ loading: true }, () => this.props.fetch(page));
  };

  onItemLinkClick = (item) => {
    this.props.onItemLinkClick && this.props.onItemLinkClick(item);
  };

  onItemHover = (item) => {
    this.props.onItemHover && this.props.onItemHover(item);
  };

  render() {
    const { loading } = this.state;
    const { notifications, userLastNotifiedDate } = this.props;
    const realTimeNotifs = notifications?.data.filter((n) => n._isRealTime) || [];
    const historyNotifs = notifications?.data.filter((n) => !n._isRealTime) || [];
    const dashboardData = historyNotifs;

    return (
      <div className="notifications-list-container">
        {realTimeNotifs.length ? (
          <>
            {!this.props.dashboard && <Divider className="first">À l'instant</Divider>}
            <List
              itemLayout="horizontal"
              dataSource={realTimeNotifs}
              renderItem={(item) => (
                <Item
                  item={item}
                  onClick={() => this.onItemLinkClick(item)}
                  userLastNotifiedDate={userLastNotifiedDate}
                  onItemHover={() => this.onItemHover(item)}
                />
              )}
            />
            {!this.props.dashboard && !!historyNotifs.length && <Divider>Historique</Divider>}
          </>
        ) : null}
        {(!realTimeNotifs.length || !!historyNotifs.length) && (
          <>
            <List
              pagination={
                this.props.dashboard
                  ? null
                  : {
                      onChange: this.fetchData,
                      total: notifications?.total,
                      pageSize: notifications?.per_page || 10,
                    }
              }
              loading={loading}
              itemLayout="horizontal"
              dataSource={historyNotifs}
              locale={{ emptyText: "Pas de notifications" }}
              renderItem={(item) => (
                <Item
                  item={item}
                  onClick={() => this.onItemLinkClick(item)}
                  userLastNotifiedDate={userLastNotifiedDate}
                />
              )}
            />
          </>
        )}
      </div>
    );
  }
}
// }
